import CustomInput from "../../atoms/customInput/CustomInput";
import SpecificButton from "../../atoms/specificButton/SpecificButton";
import { LanguageContext } from "../../utils/context/languageContext";
import { LanguageKeys } from "../../utils/languageKeys";
import { handleErrorMessage } from "../../utils/utils";
import { ArrowRight } from "lucide-react";
import React, { useContext } from "react";
import { useConfig } from "../../utils/context/configContext";

interface NameStepProps {
	onComplete: (value: any) => void;
	initialValue?: any;
	onStepComplete?: (value: any) => Promise<void> | void;
}

const NameStep = ({ onComplete, initialValue, onStepComplete }: NameStepProps) => {
	const [value, setValue] = React.useState(initialValue || "");
	const [message, setMessage] = React.useState<string | undefined>(undefined);
	const [loading, setLoading] = React.useState(false);
	const { translate } = useContext(LanguageContext) || {};
	const config = useConfig();
	const handleNext = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setLoading(true);
		try {
			if (!value.trim()) {
				setMessage(translate?.(LanguageKeys.nameRequired));
				return;
			} else {
				await onStepComplete?.(value);
				onComplete?.(value);
			}
		} catch (error) {
			setMessage(handleErrorMessage(error));
		} finally {
			setLoading(false);
		}
	};
	return (
		<div className="w-full max-w-md">
			<form onSubmit={handleNext} className="mt-[3.5rem] mb-[.75rem]">
				<div>
					<CustomInput
						required
						type="text"
						id="name"
						data-testid="onboarding-name-input"
						placeholder={translate?.(LanguageKeys.enterName)}
						onChange={(e) => {
							setValue(e.target.value);
						}}
					/>
					{message && (
						<p
							className="mt-[0.2rem] text-[16px]"
							style={{
								color: config?.style?.input?.inputErrorColor || '#000',
								fontSize: config?.style?.input?.inputErrorFontSize || '16px',
							}}
						>
							{message}
						</p>
					)}
				</div>
				<div className="flex justify-end mt-[.5rem]">
					<SpecificButton disabled={!value.trim() || loading} data-testid="onboarding-next-btn" buttonText={translate?.(LanguageKeys.next)} type="submit" postfixIcon={<ArrowRight size={14} />} />
				</div>
			</form>
		</div>
	);
};

export default NameStep;
